<template>
    <div id="Container">
        <slot />
    </div>
</template>

<script>
export default {
    data() {
        return {};
    }
};
</script>
